/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `analyzing` - 분석 중
 * `completed` - 완료
 * `failed` - 실패
 */
export type TrendAnalysisStatus =
  (typeof TrendAnalysisStatus)[keyof typeof TrendAnalysisStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendAnalysisStatus = {
  pending: "pending",
  analyzing: "analyzing",
  completed: "completed",
  failed: "failed",
} as const;
